import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/trading-area/trading-area-event.js